/* eslint-disable max-len */
import React from 'react';
import { SebMount } from './SebCommon';
import init from './SebPublicInit';
import { useSvgPlayer, useToggledMirrorAnim } from './SvgPlayerUtil';

export const SebPublic = ({ size, active }: { size?: number, active?: boolean }) => {

    const [player, setPlayerElmt] = useSvgPlayer(init);
    useToggledMirrorAnim(player, !!active);

    return <SebMount size={size}>
        <svg id="seb-public1" ref={setPlayerElmt} viewBox="0 0 55 75" shapeRendering="geometricPrecision" textRendering="geometricPrecision">
            <g transform="translate(5.03235 26.914507)">
                <g transform="translate(0 0.000001)">
                    <path
                        d="M4.08726,1.19409c0,0,10.42004,2.63,28.65004,0c0,0-2.6,18.38001,5.21,31.51001c0,0-5.21,7.88-31.25004,7.88.05,0-10.42-21.01-2.61-39.39001Z"
                        fill="#fff" />
                    <path
                        d="M4.08726,1.19409c0,0,10.42004,2.63,28.65004,0c0,0-2.6,18.38001,5.21,31.51001c0,0-5.21,7.88-31.25004,7.88.05,0-10.42-21.01-2.61-39.39001Z"
                        fill="#40b8a8" fillOpacity="0.2" />
                    <path
                        d="M6.74723,41.7942c-.2236.0009-.44325-.0591-.6353-.1736s-.34926-.2793-.4547-.4765c-.43-.88-10.57-21.7199-2.63-40.399949.11278-.266235.31644-.483763.57468-.6138s.55428-.164131.83532-.096201c.1,0,10.43997,2.53,28.17997,0c.3139-.046187.6333.032736.8896.219772s.4288.467225.4804.780228c.0194.1125.0194.2275,0,.34c0,.18-2.45,18.12005,5,30.72005.1229.1927.1881.4164.1881.645s-.0652.4522-.1881.645c-.24.33-5.9,8.41-32.23997,8.41Zm-1.92-39.20005c-6.08,15.63005,1,33.15005,2.64,36.77005c20.22997-.12,27.23997-5.17,28.99997-6.82-6.2-11.12-5.54-25.23005-5.1-29.94005-14.34,1.89-23.55997.54-26.53997-.01Z"
                        fill="#40b8a8" />
                </g>
                <path id="seb-public7" d="M12.902944,17.058627L15,17l-2.009708.145975" fill="none" stroke="#40b8a8"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path id="seb-public8"
                    d="M14.5072,19.584c1.436,0,2.6-1.1775,2.6-2.63s-1.164-2.63-2.6-2.63c-1.4359,0-2.6,1.1775-2.6,2.63s1.1641,2.63,2.6,2.63Z"
                    transform="translate(0-.043674)" fill="#40b8a8" />
                <path id="seb-public9" d="M22.905303,16.618457l-2.124276.371749l2.177383-.318642" fill="none" stroke="#40b8a8"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path id="seb-public10"
                    d="M22.3173,19.584c1.4359,0,2.6-1.1775,2.6-2.63s-1.1641-2.63-2.6-2.63-2.6,1.1775-2.6,2.63s1.1641,2.63,2.6,2.63Z"
                    fill="#40b8a8" />
                <g mask="url(#seb-public13)">
                    <path id="seb-public12"
                        d="M15,25.6986l.3075,3.5426c.205,2.3452,2.3064,4.1415,4.7666,3.9419c2.4089-.1996,4.254-2.2454,4.049-4.6404L23.8156,25L15,25.6986Z"
                        transform="translate(-1.207792-9.501297)" fill="#40b8a8" />
                    <mask id="seb-public13" mask-type="luminance" x="-150%" y="-150%" height="400%" width="400%">
                        <rect width="19.17952" height="10.870136" rx="0" ry="0"
                            transform="matrix(1.045876-.124686 0.118379 0.992969 9.149457 26.240951)" fill="#d2dbed"
                            strokeWidth="0" />
                    </mask>
                </g>
                <path id="seb-public15"
                    d="M8.56724,23.7441c-.13792.0197-.27063.0663-.39052.1372-.1199.071-.22464.1648-.30823.2763s-.14438.2383-.17892.3732c-.03453.135-.04212.2754-.02233.4133v.09c.69651,2.6272,2.34686,4.9006,4.62906,6.3767c2.2821,1.4761,5.0324,2.0489,7.7141,1.6068c2.6817-.4422,5.1025-1.8676,6.79-3.9982c1.6875-2.1307,2.5206-4.8136,2.3368-7.5253c0-.2652-.1053-.5195-.2928-.7071s-.4419-.2929-.7072-.2929h-.21l-19.35996,3.25Z"
                    fill="#40b8a8" />
                <path id="seb-public16" d="M17.724686,25.145732l1.036788-.124415" fill="none" stroke="#40b8a8" strokeWidth="2"
                    strokeLinecap="round" />
            </g>
        </svg>
    </SebMount>;
};
